// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import App from './container/homePage/home.vue'
import router from './router'
import 'lib-flexible/flexible'
import '../static/css/mui.min.css'
import mui from '../static/js/mui.min.js'
import '../static/css/base.css'
Vue.config.productionTip = false
Vue.prototype.mui = mui

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js